<template>
    <div>
        <Card>
            <Spin v-if="innerSpin" size="large" fix></Spin>
            <transition name="fade">
                <Row v-if="mainTable.sarchCardShow" :gutter="16">
                    <Col span="24">
                        <search-card
                            :form="mainTable.searchForm"
                            :table-load-event="getSeedFarmTableRecords"
                            :table-search="mainTable.tableSearch"
                        />
                    </Col>
                </Row>
            </transition>

            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">苗场管理</span>
                        </div>
                        <div class="right-bar">
                            <Button
                                v-if="$checkAccessArray(['S'])"
                                class="btns"
                                size="small"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onSeedFarmCreate"
                                >新增</Button
                            >
                            <Button
                                type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="
                                    mainTable.sarchCardShow =
                                        !mainTable.sarchCardShow
                                "
                                >搜索</Button
                            >
                        </div>
                    </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                    <stand-pagination-table
                        :columns="mainTable.columns"
                        :data="mainTable.data"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getSeedFarmTableRecords"
                    />
                </Col>
            </Row>
        </Card>

        <Modal v-model="seedFarmFormShow" title="苗场信息" width="60">
            <div class="global-tool-bar">
                <div class="left-bar">
                    <!-- <span class="title">送货单质检</span> -->
                </div>
                <div class="right-bar" style="margin-bottom: 20px">
                    <Button type="success" @click="doPrint()"
                        >打印订购告知书</Button
                    >
                </div>
            </div>
            <Form
                ref="seedFarmForm"
                :model="seedFarmForm"
                :rules="ruleValidate"
                label-position="top"
            >
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="种苗场编号" prop="seedFarmCode">
                            <Input
                                v-model="seedFarmForm.seedFarmCode"
                                :disabled="
                                    seedFarmForm.formEditMode !==
                                    FORM_EDIT_MODE_CREATE
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="种苗场名称" prop="seedFarmName">
                            <Input v-model="seedFarmForm.seedFarmName"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="所属区域" prop="seedFarmAreaUuid">
                            <Select
                                v-model="seedFarmForm.seedFarmAreaUuid"
                                filterable
                            >
                                <Option
                                    v-for="item in areaSource"
                                    :key="item.areaUuid"
                                    :value="item.areaUuid"
                                    >{{ item.areaName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <!-- <Col span="6">
                    <FormItem label="关联仓库"
                        prop="seedFarmRelateWarehouseUuid">
                        <Select v-model="seedFarmForm.seedFarmRelateWarehouseUuid"
                            filterable>
                            <Option v-for="item in warehouseSource"
                                :key="item.warehouseUuid"
                                :value="item.warehouseUuid">{{ item.warehouseName }}</Option>
                        </Select>
                    </FormItem>
                    </Col> -->
                </Row>
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="省份" prop="seedFarmProvince">
                            <Select
                                v-model="seedFarmForm.seedFarmProvince"
                                filterable
                                clearable
                                placeholder="请选择省"
                                @on-change="onProvinceChange"
                            >
                                <Option
                                    v-for="item in provinceOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid"
                                    >{{ item.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="城市" prop="seedFarmCity">
                            <Select
                                v-model="seedFarmForm.seedFarmCity"
                                filterable
                                clearable
                                placeholder="请选择市"
                                @on-change="onCityChange"
                            >
                                <Option
                                    v-for="item in cityOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid"
                                    >{{ item.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="区/县" prop="seedFarmDist">
                            <Select
                                v-model="seedFarmForm.seedFarmDist"
                                filterable
                                clearable
                                placeholder="请选择区/县"
                            >
                                <Option
                                    v-for="item in distOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid"
                                    >{{ item.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <!-- <Col span="6">
                    <FormItem label="类型"
                        prop="seedFarmType">
                        <Select v-model="seedFarmForm.seedFarmType"
                            :disabled="seedFarmForm.formEditMode !== FORM_EDIT_MODE_CREATE"
                            filterable>
                            <Option v-for="item in seedFarmTypeList"
                                :key="item"
                                :value="item">{{ item }}</Option>
                        </Select>
                    </FormItem>
                    </Col> -->
                    <Col span="6">
                        <FormItem label="地址">
                            <Input
                                v-model="seedFarmForm.seedFarmAddress"
                            ></Input>
                        </FormItem>
                    </Col>

                    <Col span="6">
                        <FormItem label="联系人">
                            <Input
                                v-model="seedFarmForm.seedFarmContact"
                            ></Input>
                        </FormItem>
                    </Col>

                    <Col span="6">
                        <FormItem label="联系电话" prop="seedFarmContactPhone">
                            <Input
                                v-model="seedFarmForm.seedFarmContactPhone"
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <!-- <Col span="6">
                    <FormItem label="品种名称"
                        prop="brandVarietyName">
                        <Input v-model="seedFarmForm.brandVarietyName"></Input>
                    </FormItem>
                    </Col> -->

                    <Col span="6">
                        <FormItem label="品牌名称" prop="brandName">
                            <Input v-model="seedFarmForm.brandName"></Input>
                        </FormItem>
                    </Col>

                    <!-- <Col span="6">
                      <FormItem label="用友部门" prop="ysDeptCode">
                        <Select
                          v-model="seedFarmForm.ysDeptCode"
                          clearable
                          filterable
                          @on-select="onSelectYSDept">
                          <Option
                            v-for="item in YSDeptOptions"
                            :key="item.code"
                            :value="item.code">{{ item.code }} - {{ item.name}}</Option>
                        </Select>
                      </FormItem>
                    </Col> -->
                    <Col span="6">
                        <FormItem label="默认转运站">
                            <Select
                                v-model="seedFarmForm.defaultDtbStationsUuid"
                                clearable
                                filterable
                            >
                                <Option
                                    v-for="(item, index) in distributionStationsOptions"
                                    :key="index"
                                    :value="item.id"
                                    >{{ item.code }} - {{ item.name }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6">

                        <FormItem label="部门" prop="department">
                            <Select
                                v-model="seedFarmForm.departmentUuid"
                                clearable
                                filterable
                            >
                                <Option
                                    v-for="item in departmentList"
                                    :key="item.departmentUuid"
                                    :value="item.departmentUuid"
                                    >{{ item.departmentName }}</Option
                                >
                            </Select>
                        </FormItem>

                    </Col>

                    <!-- <Col span="6">
                    <FormItem label="品牌代码"
                        prop="brandCode">
                        <Input v-model="seedFarmForm.brandCode"></Input>
                    </FormItem>
                    </Col> -->
                </Row>
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="选择发货日期" prop="seedFarmDeliveryWeek">
                            <Select v-model="seedFarmForm.seedFarmDeliveryWeek" placeholder="请选择">
                              <Option v-for="(day, index) in deliveryDays" :key="index" :value="day.value">{{ day.label }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                  <Col span="24">
                        <FormItem label="苗场介绍" prop="seedFarmIntroduction">
                            <Input
                                v-model="seedFarmForm.seedFarmIntroduction"
                                :rows="5"
                                type="textarea"
                            ></Input>
                        </FormItem>
                    </Col>

                    <Col span="24">
                        <FormItem label="种苗定购告知书" prop="noticeContent">
                            <Input
                                id="printContent"
                                v-model="seedFarmForm.noticeContent"
                                :rows="30"
                                type="textarea"
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <FormItem label="示范视频">
                            <template>
                                <Upload
                                    action="https://up-z2.qiniup.com/"
                                    :data="uploadParams"
                                    :format="['mp4']"
                                    accept=".mp4"
                                    :on-format-error="handleFormatError"
                                    :on-success="handleUploadVideoSuccess"
                                    :before-upload="beforeVideoUpload"
                                    :show-upload-list="showUploadList"
                                    v-if="
                                        readOnly == false &&
                                        demonVideos.length < 5
                                    "
                                >
                                    <Button icon="ios-cloud-upload-outline"
                                        >上传视频</Button
                                    >
                                </Upload>

                                <Row :gutter="16" style="margin-top: 10px">
                                    <Col
                                        span="5"
                                        v-for="(item, index) in demonVideos"
                                        :key="index"
                                    >
                                        <div class="img-card">
                                            <video
                                                width="150"
                                                height="150"
                                                controls
                                            >
                                                <source
                                                    :src="item.src"
                                                    type="video/mp4"
                                                />
                                            </video>
                                            <Icon
                                                type="md-trash"
                                                class="icon-delete"
                                                @click="deleteVideo(index)"
                                                v-if="readOnly == false"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </template>
                        </FormItem>
                    </Col>
                </Row>

                <!-- <Row :gutter="16">
                    <Col span="6">
                    <FormItem label="主图">
                        <single-file-upload-with-name v-model="seedFarmForm.brandMainImageFile" />
                    </FormItem>
                    </Col>
                    <Col span="6">
                    <FormItem label="缩图">
                        <single-file-upload-with-name v-model="seedFarmForm.brandThumbnailFile" />
                    </FormItem>
                    </Col>
                </Row> -->
            </Form>
            <div slot="footer">
                <Button
                    type="primary"
                    @click="onSave"
                    v-if="$checkAccessArray(['S', 'B', 'C'])"
                    >确认</Button
                >
                <Button type="error" @click="onCancel">取消</Button>
            </div>
        </Modal>

        <Modal v-model="seedFarmDeptFormShow" title="苗场信息" width="60">
            <div class="global-tool-bar">
                <div class="left-bar"></div>
            </div>
            <Form
                ref="seedFarmDeptForm"
                :model="seedFarmForm"
                :rules="ruleValidate"
                label-position="top"
            >
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="种苗场编号" prop="seedFarmCode">
                            <Input
                                v-model="seedFarmForm.seedFarmCode"
                                disabled
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="种苗场名称" prop="seedFarmName">
                            <Input
                                v-model="seedFarmForm.seedFarmName"
                                readonly
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="用友部门" prop="ysDeptCode">
                            <Select
                                v-model="seedFarmForm.ysDeptCode"
                                clearable
                                filterable
                                @on-select="onSelectYSDept"
                            >
                                <Option
                                    v-for="item in YSDeptOptions"
                                    :key="item.code"
                                    :value="item.code"
                                    >{{ item.code }} - {{ item.name }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button
                    type="primary"
                    @click="onDeptSave"
                    v-if="$checkAccessArray(['R','S'])"
                    >确认</Button
                >
                <Button type="error" @click="seedFarmDeptFormShow = false"
                    >取消</Button
                >
            </div>
        </Modal>

        <Modal
            v-model="seedFarmDepositDueRateFormShow"
            title="苗场定金比例设置"
        >
            <Form
                ref="seedFarmDepositDue"
                :model="seedFarmDepositDueRateForm"
                label-position="top"
            >
                <Row :gutter="24">
                    <Col span="12">
                        <FormItem label="种苗场编号" prop="seedFarmCodeB">
                            <Input
                                v-model="
                                    seedFarmDepositDueRateForm.seedFarmCode
                                "
                                disabled
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="种苗场名称" prop="seedFarmNameB">
                            <Input
                                v-model="
                                    seedFarmDepositDueRateForm.seedFarmName
                                "
                                disabled
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="24">
                        <FormItem
                            label="最低定金比例(百分比,如10即为10%,如0即为苗场代下单时,可将定金比例调整至0)"
                        >
                            <Input
                                v-model="
                                    seedFarmDepositDueRateForm.depositDueRate
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="24">
                        <FormItem label="是否启用">
                            <RadioGroup
                                v-model="seedFarmDepositDueRateForm.isEnable"
                                style=""
                            >
                                <Radio label="启用"> <span>启用</span></Radio>
                                <Radio label="停用"> <span>停用</span></Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button
                    type="primary"
                    @click="onSaveDepositDueRate"
                    v-if="$checkAccessArray(['S'])"
                    >确认</Button
                >
                <Button type="error" @click="onCancelDepositDueRate"
                    >取消</Button
                >
            </div>
        </Modal>
        <Modal v-model="seedFarmLinkPreSalePlansShow" title="联动供货数据">
            <Form
                ref="seedFarmLinkPlans"
                :model="seedFarmDepositDueRateForm"
                label-position="top"
            >
                <Row :gutter="24">
                    <Col span="12">
                        <FormItem label="种苗场编号" prop="seedFarmCodeB">
                            <Input
                                v-model="
                                    seedFarmDepositDueRateForm.seedFarmCode
                                "
                                disabled
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="种苗场名称" prop="seedFarmNameB">
                            <Input
                                v-model="
                                    seedFarmDepositDueRateForm.seedFarmName
                                "
                                disabled
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="24">
                    <Col span="12">
                        <FormItem label="联动供货数据" prop="seedFarmCodeB">
                            <i-switch
                                v-model="
                                    seedFarmDepositDueRateForm.linkPreSalePlans
                                "
                                size="large"
                            >
                                <template>
                                    <span slot="open">开启</span>
                                </template>
                                <template>
                                    <span slot="close">关闭</span>
                                </template>
                            </i-switch>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button
                    type="primary"
                    @click="onSaveLinkPlans"
                    v-if="$checkAccessArray(['B', 'S'])"
                    >确认</Button
                >
                <Button type="error" @click="onCancelLinkPlans">取消</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import SingleFileUploadWithName from "@/components/single-file-upload-with-name/SingleFileUploadWithName";
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from "@/view/mixins/form-edit-mode";
// import {
//     SEED_FARM_TYPE_BIN_FEN,
//     SEED_FARM_TYPE_EXTERNAL
// } from '@/view/system-management/area-management/SeedFarmTypeDefine';

import {
    getSeedFarmList,
    pageInit4SeedFarmEdit,
    saveSeedFarm,
    saveSeedFarmDept,
    updateSeedFarmsDepositDueRate,
    updateSeedFarmsAutoCheckIntention,
    saveSeedFarmDepositDueRate,
    saveSeedFarmLinkPreSalePlans,
    getRelateList,
    getBugProductCodeListBySeedFarmUuid
} from "@/api/modules/system-management/seedFarm-management";
import { dateTimeRender } from "@/libs/tableRowTimeRender";
import { getDistributionStationList } from "@/api/modules/system-management/distributionStation-management.js";
import { qiniuToken } from "@/api/modules/product-management/product-management";
import { webGetAllRegion } from "@/api/modules/system-management/region-management";
import { statusAcceptFormat } from "@/libs/baseModelFormat";
import { getDepartmentList } from '@/api/modules/system-management/department-management';
import { getCompanyList } from '@/api/modules/system-management/company-management';
export default {
    name: "SeedFarmList",
    components: {
        StandPaginationTable,
        SingleFileUploadWithName,
        SearchCard
    },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            departmentList: [],
            companyList: [],
            imageDomain: this.imageDomain,
            seedFarmLinkPreSalePlansShow: false,
            demonVideos: [],
            showUploadList: false,
            uploadParams: {},
            innerSpin: false,
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            allRegions: [],
            provinceOptions: [],
            cityOptions: [],
            distOptions: [],
            YSDeptOptions: [],
            distributionStationsOptions: [],
            seedFarmForm: {
                formEditMode: "",
                seedFarmCode: "",
                seedFarmUuid: "",
                seedFarmName: "",
                seedFarmAddress: "",
                seedFarmAreaUuid: "",
                seedFarmProvince: "",
                seedFarmCity: "",
                seedFarmDist: "",
                seedFarmRelateWarehouseUuid: "",
                seedFarmContact: "",
                seedFarmContactPhone: "",
                brandVarietyName: "",
                brandName: "",
                brandCode: "",
                brandMainImageFile: "",
                brandThumbnailFile: "",
                noticeContent: "",
                ysDeptId: "",
                ysDeptCode: "",
                ysDeptName: "",
                defaultDtbStationsUuid: "",
                companyUuid: "",
                departmentUuid: "",
                seedFarmDeliveryWeek:''
            },
            seedFarmDepositDueRateForm: {
                seedFarmUuid: "",
                seedFarmCode: "",
                seedFarmName: "",
                depositDueRate: 20,
                isEnable: "停用",
                linkPreSalePlans: false
            },
            seedFarmFormShow: false,
            seedFarmDeptFormShow: false,
            seedFarmDepositDueRateFormShow: false,
            mainTable: {
                columns: [
                    {
                        title: "行号",
                        type: "index",
                        width: 40,
                        align: "center"
                    },
                    {
                        title: "种苗场编号",
                        key: "seedFarmCode",
                        align: "center"
                    },
                    {
                        title: "种苗场名称",
                        key: "seedFarmName",
                        align: "center"
                    },
                    {
                        title: "关联用友部门编号",
                        key: "ysDeptCode",
                        align: "center"
                    },
                    {
                        title: "关联用友部门",
                        key: "ysDeptName",
                        align: "center"
                    },
                    {
                        title: "佣金比例(%)",
                        key: "commissionRate",
                        align: "center"
                    },
                    { title: "区域", key: "areaName", align: "center" },
                    { title: "省份", key: "province", align: "center" },
                    { title: "城市", key: "city", width: 60, align: "center" },
                    { title: "区/县", key: "dist", align: "center" },
                    { title: "地址", key: "seedFarmAddress", align: "center" },
                    { title: "品牌", key: "brandName", align: "center" },
                    // { title: '关联仓库', key: 'warehouseName', align: 'center' },
                    {
                        title: "联系人",
                        key: "seedFarmContact",
                        align: "center"
                    },
                    {
                        title: "联系电话",
                        key: "seedFarmContactPhone",
                        align: "center"
                    },
                    {
                        title: "定金比例(%)",
                        key: "depositDueRate",
                        width: 50,
                        align: "center"
                    },
                    {
                        title: "默认转运站",
                        key: "distributionStationName",
                        width: 80,
                        align: "center"
                    },
                    { title: "更新人", key: "userPersonName", align: "center" },
                    {
                        title: "更新时间",
                        key: "seedFarmUpdateAt",
                        align: "center",
                        render: (h, params) =>
                            dateTimeRender(h, params.row.seedFarmUpdateAt)
                    },

                    {
                        title: "是否取整",
                        key: "recordStatusInt",
                        align: "center",
                        width: 40,
                        render: (h, params) => {
                            let btnText
                                = params.row.recordStatusInt == 1 ? "是" : "否";
                            let allowedTypes = this.personType.split(",");
                            // 检查数组中是否包含 'B' 或 'S'
                            let isDisabled
                                = allowedTypes.includes("B")
                                || allowedTypes.includes("S");
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {
                                            color:
                                                params.row.recordStatusInt == 1
                                                    ? "#006400"
                                                    : "#4298f2"
                                        },
                                        on: {
                                            click: () => {
                                                if (isDisabled) {
                                                    this.onUpdateSeedFarmsDepositDueRate(
                                                        params.row
                                                    );
                                                }
                                            }
                                        }
                                    },
                                    btnText
                                )
                            ]);
                        }
                    },
                    {
                        title: "是否自动审核意向单",
                        key: "autoCheckIntention ",
                        align: "center",
                        width: 40,
                        render: (h, params) => {
                            let btnText
                                = params.row.autoCheckIntention == 1
                                    ? "是"
                                    : "否";
                            let allowedTypes = this.personType.split(",");
                            // 检查数组中是否包含 'B' 或 'S'
                            let isDisabled
                                = allowedTypes.includes("B")
                                || allowedTypes.includes("S");
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {
                                            color:
                                                params.row.autoCheckIntention
                                                == 1
                                                    ? "#006400"
                                                    : "#4298f2"
                                        },
                                        on: {
                                            click: () => {
                                                if (isDisabled) {
                                                    this.onUpdateSeedFarmsAutoCheckIntention(
                                                        params.row
                                                    );
                                                }
                                            }
                                        }
                                    },
                                    btnText
                                )
                            ]);
                        }
                    },
                    {
                        title: "定金比例状态",
                        key: "isEnable",
                        width: 50,
                        align: "center"
                    },
                    {
                        title: "联动供货计划",
                        key: "linkPreSalePlans",
                        width: 50,
                        align: "center",
                        render: (h, params) => {
                            let text = params.row.linkPreSalePlans
                                ? "是"
                                : "否";
                            let allowedTypes = this.personType.split(",");
                            // 检查数组中是否包含 'B' 或 'S'
                            let isDisabled
                                = allowedTypes.includes("B")
                                || allowedTypes.includes("S");
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {
                                            color: params.row.linkPreSalePlans
                                                ? "#ff9900"
                                                : "black"
                                        },
                                        on: {
                                            click: () => {
                                                if (isDisabled) {
                                                    this.onSaveLinkPlans(
                                                        params.row
                                                    );
                                                }
                                            }
                                        }
                                    },
                                    text
                                )
                            ]);
                        }
                    },
                    {
                        title: "是否有供货",
                        key: "isPlanSale",
                        width: 50,
                        align: "center",
                        render: (h, params) => {
                            let text
                                = params.row.isPlanSale === 1 ? "是" : "否";
                            return h("span", text);
                        }
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 100,
                        render: (h, params) => {
                            const text = this.$checkAccessArray(["S"])
                                ? "编辑"
                                : "查看";

                            const data = h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {},
                                        on: {
                                            click: () => {
                                                this.onSeedFarmUpdate(
                                                    params.row
                                                );
                                            }
                                        }
                                    },
                                    text
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {},
                                        on: {
                                            click: () => {
                                                this.onSaveSeedFarmDepositDueRate(
                                                    params.row
                                                );
                                            }
                                        }
                                    },
                                    "设置定金比例"
                                )
                            ]);
                            if (this.$checkAccessArray(["R", "S"])) {
                                data.children.push(h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {},
                                        on: {
                                            click: () => {
                                                this.onSeedFarmDeptUpdate(
                                                    params.row
                                                );
                                            }
                                        }
                                    },
                                    "修改YS部门信息"
                                ))
                            }
                            return data
                        }
                    },
                    {
                        title: "商品显示情况",
                        key: "productBugCount",
                        width: 100,
                        align: "center",
                        render: (h, params) => {
                            let text
                                = "异常数量(" + params.row.productBugCount + ")";
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {
                                            color: "#ff9900"
                                        },
                                        on: {
                                            click: () => {
                                                if (
                                                    params.row
                                                        .productBugCount
                                                    && params.row.productBugCount
                                                        > 0
                                                ) {
                                                    this.getBugProductCodeList(
                                                        params.row.seedFarmUuid
                                                    );
                                                }
                                            }
                                        }
                                    },
                                    text
                                )
                            ]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    {
                        label: "苗场编号",
                        type: "Input",
                        value: "",
                        name: "seedFarmCode",
                        sql: "like"
                    },
                    {
                        label: "种苗场名称",
                        type: "Input",
                        value: "",
                        name: "seedFarmName",
                        sql: "like"
                    },
                    {
                        label: "联系人",
                        type: "Input",
                        value: "",
                        name: "seedFarmContact",
                        sql: "like"
                    },
                    {
                        label: "联系电话",
                        type: "Input",
                        value: "",
                        name: "seedFarmContactPhone",
                        sql: "like"
                    },
                    {
                        label: "苗场介绍",
                        type: "Input",
                        value: "",
                        name: "seedFarmIntroduction",
                        sql: "like"
                    }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            areaSource: [],
            // warehouseSource: [],
            ruleValidate: {
                seedFarmCode: [
                    { required: true, message: " ", trigger: "blur" }
                ],
                seedFarmName: [
                    { required: true, message: " ", trigger: "blur" }
                ],
                seedFarmAreaUuid: [
                    { required: true, message: " ", trigger: "blur" }
                ],
                seedFarmProvince: [
                    { required: true, message: " ", trigger: "blur" }
                ],
                seedFarmCity: [
                    { required: true, message: " ", trigger: "blur" }
                ],
                seedFarmDist: [
                    { required: true, message: " ", trigger: "blur" }
                ],
                brandName: [{ required: true, message: " ", trigger: "blur" }],
                seedFarmRelateWarehouseUuid: [
                    { required: true, message: " ", trigger: "blur" }
                ],
                seedFarmContactPhone: [
                    {
                        pattern:
                            /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/,
                        required: true,
                        message: "手机号码格式不正确 ",
                        trigger: "blur"
                    }
                ]
                // noticeContent: [{ required: true, message: '请填写种苗定购告知书', trigger: 'blur' }],
            },
            deliveryDays: [{ value: 1, label: '星期一' }, { value: 2, label: '星期二' }, { value: 3, label: '星期三' }, { value: 4, label: '星期四' }, { value: 5, label: '星期五' }, { value: 6, label: '星期六' }, { value: 0, label: '星期日' }]
        };
    },
    computed: {
        // seedFarmTypeList() {
        //     return [SEED_FARM_TYPE_BIN_FEN, SEED_FARM_TYPE_EXTERNAL];
        // }
        // // 获取用户类型
        personType() {
            return this.$store.state.user.personType;
        }
    },
    created() {
        if (this.readOnly) {
            const findIndex = this.mainTable.columns.findIndex(
                (c) => c.title === "操作"
            );
            if (findIndex >= 0) {
                this.mainTable.columns.splice(findIndex, 1);
            }
        }
        this.removeColumn();
    },
    mounted() {
        this.getDepartmentList();
        this.innerSpin = true;
        pageInit4SeedFarmEdit()
            .then((res) => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.areaSource = res.data.area.records.map((item) => {
                        return {
                            areaUuid: item.areaUuid,
                            areaName: item.areaName
                        };
                    });

                    // this.warehouseSource = res.data.warehouse.records.map(item => {
                    //     return {
                    //         warehouseUuid: item.warehouseUuid,
                    //         warehouseName: item.warehouseName
                    //     };
                    // });
                    this.getRelateOptions();
                    this.getSeedFarmTableRecords();
                    this.getDistributionStationList();
                }
            })
            .catch(() => {
                this.innerSpin = false;
            });
    },
    methods: {
        onUpdateSeedFarmsDepositDueRate(row) {
            let recordStatusInt = row.recordStatusInt == 0 ? 1 : 0;
            this.$Modal.confirm({
                title:
                    "当前定金取整为"
                    + statusAcceptFormat(row.recordStatusInt)
                    + ",是否变更为"
                    + statusAcceptFormat(recordStatusInt)
                    + "？",
                onOk: () => {
                    this.innerSpin = true;
                    updateSeedFarmsDepositDueRate({
                        seedFarmUuid: row.seedFarmUuid,
                        recordStatusInt: recordStatusInt
                    })
                        .then((res) => {
                            if (res.code === 0) {
                                this.$Message.info("保存成功");
                            }
                        })
                        .finally(() => {
                            setTimeout(() => {
                                this.innerSpin = false;
                                this.getSeedFarmTableRecords();
                            }, 400);
                        });
                }
            });
        },
        onUpdateSeedFarmsAutoCheckIntention(row) {
            let autoCheckIntention = row.autoCheckIntention == 1 ? 0 : 1;
            this.$Modal.confirm({
                title:
                    "当前自动审核意向单为"
                    + statusAcceptFormat(row.autoCheckIntention)
                    + ",是否变更为"
                    + statusAcceptFormat(autoCheckIntention)
                    + "？",
                onOk: () => {
                    this.innerSpin = true;
                    updateSeedFarmsAutoCheckIntention({
                        seedFarmUuid: row.seedFarmUuid,
                        checkStatusInt: autoCheckIntention
                    })
                        .then((res) => {
                            if (res.code === 0) {
                                this.$Message.info("保存成功");
                            }
                        })
                        .finally(() => {
                            setTimeout(() => {
                                this.innerSpin = false;
                                this.getSeedFarmTableRecords();
                            }, 400);
                        });
                }
            });
        },
        doPrint() {
            printJS({
                printable: "printContent",
                type: "html",
                targetStyles: ["padding-top"],
                maxWidth: 1920
            });
        },
        handleFormatError(request, file) {
            this.$Notice.warning({
                title: "格式错误",
                desc: "请上传mp4格式文件"
            });
        },
        getRegionList() {
            webGetAllRegion().then((res) => {
                if (res.code === 0) {
                    this.allRegions = res.data.allRegions;
                    this.provinceOptions = this.allRegions.filter(
                        (r) => r.regionType === 1
                    );
                    this.cityOptions = [];
                    this.distOptions = [];
                }
            });
        },
        onProvinceChange(provinceUuid) {
            this.distOptions = [];
            this.cityOptions = this.allRegions.filter(
                (r) => r.regionType === 2 && r.regionParentUuid === provinceUuid
            );
        },
        onCityChange(cityUuid) {
            this.distOptions = this.allRegions.filter(
                (r) => r.regionType === 3 && r.regionParentUuid === cityUuid
            );
        },
        async beforeVideoUpload(request) {
            // **注意这里的参数必须通过属性赋值，如果直接修改整个uploadParams是无效的。**
            // 上传之前设置上传参数,
            let suffix = request.name.substring(request.name.lastIndexOf("."));
            let filename
                = Date.now() + Math.random().toString(36).slice(2) + suffix;
            await qiniuToken({}).then((res) => {
                this.uploadParams.token = res.data.token;
                // 七牛response hash key的值自定义，后面如果需要浏览或者下载都需要这个地址，如果key不定义，那么七牛生成的key === hash的值
                this.uploadParams.key = filename;
            });
        },
        handleUploadVideoSuccess(request, file, list) {
            let videoPath = this.imageDomain + file.response.key;
            this.demonVideos.push({ id: "", src: videoPath, size: file.size });
        },
        // 删除视频
        deleteVideo(index) {
            this.$Modal.confirm({
                title: "确认",
                content: "是否删除视频？",
                onOk: () => {
                    this.demonVideos.splice(index, 1);
                }
            });
        },
        getSeedFarmTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getSeedFarmList(this.mainTable.tableSearch)
                .then((res) => {
                    if (res.code === 0) {
                        this.mainTable.data = res.data.records;
                        search.globalSetFilterRecordCount(
                            this.mainTable.tableSearch,
                            res.data.filterRecordCount
                        );
                    }

                    this.mainTable.loading = false;
                })
                .catch(() => {
                    this.mainTable.loading = false;
                });
        },
        onSeedFarmCreate() {
            this.seedFarmForm.formEditMode = FORM_EDIT_MODE_CREATE;
            this.seedFarmForm.seedFarmUuid = "";
            this.seedFarmForm.seedFarmCode = "";
            this.seedFarmForm.seedFarmName = "";
            this.seedFarmForm.seedFarmAddress = "";
            this.seedFarmForm.seedFarmAreaUuid = "";
            this.seedFarmForm.seedFarmProvince = "";
            this.seedFarmForm.seedFarmCity = "";
            this.seedFarmForm.seedFarmDist = "";
            this.seedFarmForm.seedFarmRelateWarehouseUuid = "";
            this.seedFarmForm.seedFarmContact = "";
            this.seedFarmForm.seedFarmContactPhone = "";
            this.seedFarmForm.brandVarietyName = "";
            this.seedFarmForm.brandName = "";
            this.seedFarmForm.brandCode = "";
            this.seedFarmForm.brandMainImageFile = "";
            this.seedFarmForm.brandThumbnailFile = "";
            this.seedFarmForm.brandUuid = "";
            this.seedFarmForm.demoVideo = "";
            this.seedFarmForm.noticeContent = "";
            this.seedFarmForm.ysDeptId = "";
            this.seedFarmForm.ysDeptCode = "";
            this.seedFarmForm.ysDeptName = "";
            this.seedFarmForm.defaultDtbStationsUuid = "";
            this.seedFarmForm.companyUuid = "";
            this.seedFarmForm.departmentUuid = "";
            this.seedFarmFormShow = true;
        },
        onSeedFarmUpdate(row) {
            this.seedFarmForm.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.seedFarmForm.seedFarmUuid = row.seedFarmUuid;
            this.seedFarmForm.seedFarmCode = row.seedFarmCode;
            this.seedFarmForm.seedFarmName = row.seedFarmName;
            this.seedFarmForm.seedFarmAddress = row.seedFarmAddress;
            this.seedFarmForm.seedFarmAreaUuid = row.seedFarmAreaUuid;
            this.seedFarmForm.seedFarmProvince = row.seedFarmProvince;
            this.seedFarmForm.seedFarmCity = row.seedFarmCity;
            this.seedFarmForm.seedFarmDist = row.seedFarmDist;
            this.seedFarmForm.seedFarmRelateWarehouseUuid = row.seedFarmRelateWarehouseUuid;
            this.seedFarmForm.seedFarmContact = row.seedFarmContact;
            this.seedFarmForm.seedFarmContactPhone = row.seedFarmContactPhone;
            this.seedFarmForm.brandVarietyName = row.brandVarietyName;
            this.seedFarmForm.brandName = row.brandName;
            this.seedFarmForm.brandCode = row.brandCode;
            this.seedFarmForm.brandMainImageFile = row.brandMainImageFile;
            this.seedFarmForm.brandThumbnailFile = row.brandThumbnailFile;
            this.seedFarmForm.brandUuid = row.brandUuid;
            this.seedFarmForm.demoVideo = row.demoVideo;
            this.seedFarmForm.noticeContent = row.noticeContent;
            this.seedFarmForm.ysDeptId = row.ysDeptId;
            this.seedFarmForm.ysDeptCode = row.ysDeptCode;
            this.seedFarmForm.ysDeptName = row.ysDeptName;
            this.seedFarmForm.defaultDtbStationsUuid = row.defaultDtbStationsUuid;
            this.seedFarmForm.seedFarmIntroduction = row.seedFarmIntroduction;
            this.seedFarmForm.companyUuid = row.companyUuid;
            this.seedFarmForm.departmentUuid = row.departmentUuid;
            this.seedFarmForm.seedFarmDeliveryWeek = row.seedFarmDeliveryWeek;
            this.cityOptions = this.allRegions.filter(
                (r) =>
                    r.regionType === 2 && r.regionParentUuid === row.seedFarmProvince
            );
            this.distOptions = this.allRegions.filter(
                (r) =>
                    r.regionType === 3 && r.regionParentUuid === row.seedFarmCity
            );
            this.demonVideos = [];
            if (this.seedFarmForm.demoVideo) {
                let videosArr = this.seedFarmForm.demoVideo.split(",");
                videosArr.forEach((item) => {
                    this.demonVideos.push({
                        id: "",
                        src: this.imageDomain + item,
                        size: 0
                    });
                });
            }
            this.seedFarmFormShow = true;
        },
        onSeedFarmDeptUpdate(row) {
            this.seedFarmForm.seedFarmUuid = row.seedFarmUuid;
            this.seedFarmForm.seedFarmCode = row.seedFarmCode;
            this.seedFarmForm.seedFarmName = row.seedFarmName;
            this.seedFarmForm.seedFarmAddress = row.seedFarmAddress;
            this.seedFarmForm.seedFarmAreaUuid = row.seedFarmAreaUuid;
            this.seedFarmForm.seedFarmProvince = row.seedFarmProvince;
            this.seedFarmForm.seedFarmCity = row.seedFarmCity;
            this.seedFarmForm.seedFarmDist = row.seedFarmDist;
            this.seedFarmForm.seedFarmRelateWarehouseUuid = row.seedFarmRelateWarehouseUuid;
            this.seedFarmForm.seedFarmContact = row.seedFarmContact;
            this.seedFarmForm.seedFarmContactPhone = row.seedFarmContactPhone;
            this.seedFarmForm.brandVarietyName = row.brandVarietyName;
            this.seedFarmForm.brandName = row.brandName;
            this.seedFarmForm.brandCode = row.brandCode;
            this.seedFarmForm.brandMainImageFile = row.brandMainImageFile;
            this.seedFarmForm.brandThumbnailFile = row.brandThumbnailFile;
            this.seedFarmForm.brandUuid = row.brandUuid;
            this.seedFarmForm.demoVideo = row.demoVideo;
            this.seedFarmForm.noticeContent = row.noticeContent;
            this.seedFarmForm.ysDeptId = row.ysDeptId;
            this.seedFarmForm.ysDeptCode = row.ysDeptCode;
            this.seedFarmForm.ysDeptName = row.ysDeptName;
            this.seedFarmForm.companyUuid = row.companyUuid;
            this.seedFarmForm.departmentUuid = row.departmentUuid;
            this.seedFarmDeptFormShow = true;
        },
        onCancel() {
            this.seedFarmFormShow = false;
        },
        onSave() {
            this.$refs.seedFarmForm.validate((valid) => {
                if (!valid) {
                    this.$Message.error("表单验证失败!");
                    return;
                }
                this.seedFarmForm.demoVideo = "";
                if (this.demonVideos.length == 0) {
                    this.seedFarmForm.demoVideo = "";
                }
                else {
                    this.demonVideos.forEach((item) => {
                        if (this.seedFarmForm.demoVideo == "") {
                            this.seedFarmForm.demoVideo += item.src.replaceAll(
                                this.imageDomain,
                                ""
                            );
                        }
                        else {
                            this.seedFarmForm.demoVideo
                                += "," + item.src.replaceAll(this.imageDomain, "");
                        }
                    });
                }
                const data = Object.assign({}, this.seedFarmForm);
                saveSeedFarm(data).then((res) => {
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "保存成功",
                            onOk: () => {
                                this.seedFarmFormShow = false;
                                this.getSeedFarmTableRecords();
                            }
                        });
                    }
                });
            });
        },
        onDeptSave() {
            if (!this.seedFarmForm.ysDeptCode) {
                this.$Message.error("Ys部门编码不能为空!");
                return;
            }

            if (!this.seedFarmForm.ysDeptId) {
                this.$Message.error("Ys部门Id不能为空!");
                return;
            }

            if (!this.seedFarmForm.ysDeptName) {
                this.$Message.error("Ys部门名称不能为空!");
                return;
            }
            const data = Object.assign({}, this.seedFarmForm);
            saveSeedFarmDept(data).then((res) => {
                if (res.code === 0) {
                    this.$Modal.success({
                        title: "保存成功",
                        onOk: () => {
                            this.seedFarmDeptFormShow = false;
                            this.getSeedFarmTableRecords();
                        }
                    });
                }
            });
        },
        onSaveSeedFarmDepositDueRate(row) {
            this.seedFarmDepositDueRateForm.seedFarmUuid = row.seedFarmUuid;
            this.seedFarmDepositDueRateForm.seedFarmCode = row.seedFarmCode;
            this.seedFarmDepositDueRateForm.seedFarmName = row.seedFarmName;
            this.seedFarmDepositDueRateForm.depositDueRate = row.depositDueRate;
            this.seedFarmDepositDueRateForm.isEnable = row.isEnable;
            this.seedFarmDepositDueRateFormShow = true;
        },
        onSaveDepositDueRate() {
            if (
                this.seedFarmDepositDueRateForm.depositDueRate == null
                || this.seedFarmDepositDueRateForm.depositDueRate == undefined
            ) {
                this.$Message.error("请填写定金比例!");
                return;
            }
            if (
                this.seedFarmDepositDueRateForm.depositDueRate < 0
                || this.seedFarmDepositDueRateForm.depositDueRate > 100
            ) {
                this.$Message.error("定金比例不能输入小于0或者大于100!");
                return;
            }
            const data = {
                seedFarmUuid: this.seedFarmDepositDueRateForm.seedFarmUuid,
                depositDueRate: this.seedFarmDepositDueRateForm.depositDueRate,
                isEnable: this.seedFarmDepositDueRateForm.isEnable
            };
            saveSeedFarmDepositDueRate(data).then((res) => {
                if (res.code === 0) {
                    this.$Modal.success({
                        title: "保存成功",
                        onOk: () => {
                            this.seedFarmDepositDueRateFormShow = false;
                            this.getSeedFarmTableRecords();
                        }
                    });
                }
            });
        },
        onCancelDepositDueRate() {
            this.seedFarmDepositDueRateFormShow = false;
        },
        linkPlan(row) {
            this.seedFarmLinkPreSalePlansShow = true;
            this.seedFarmDepositDueRateForm.seedFarmUuid = row.seedFarmUuid;
            this.seedFarmDepositDueRateForm.seedFarmCode = row.seedFarmCode;
            this.seedFarmDepositDueRateForm.seedFarmName = row.seedFarmName;
            this.seedFarmDepositDueRateForm.linkPreSalePlans
                = row.linkPreSalePlans == null ? 0 : row.linkPreSalePlans;
        },
        onSaveLinkPlans(row) {
            this.$Modal.confirm({
                title: "是否改变当前供货计划状态？",
                onOk: () => {
                    this.innerSpin = true;
                    saveSeedFarmLinkPreSalePlans({
                        seedFarmUuid: row.seedFarmUuid,
                        linkPreSalePlans: !row.linkPreSalePlans
                    })
                        .then((res) => {
                            if (res.code === 0) {
                                this.$Message.info("保存成功");
                            }
                        })
                        .finally(() => {
                            setTimeout(() => {
                                this.innerSpin = false;
                                this.getSeedFarmTableRecords();
                            }, 400);
                        });
                }
            });
        },
        onCancelLinkPlans() {},
        getRelateOptions() {
            getRelateList().then((res) => {
                console.log("res:", res);
                if (res.code === 0) {
                    this.allRegions = res.data.allRegions;
                    this.provinceOptions = res.data.provinceOptions;
                    this.cityOptions = res.data.cityOptions;
                    this.distOptions = res.data.distOptions;
                    this.YSDeptOptions = res.data.YSDeptOptions;
                }
            });
        },
        getDistributionStationList() {
            let data = search.getSearchParams();
            data.filters.conditions.push({
                name: "distributionStationStatus",
                type: "eq",
                value: 1
            });
            data.filters.enable = true;
            data.limit.enable = false;
            getDistributionStationList(data).then((res) => {
                if (res.code == 0) {
                    this.distributionStationsOptions = res.data.records.map(
                        (item) => {
                            return {
                                name: item.distributionStationName,
                                code: item.distributionStationCode,
                                id: item.distributionStationUuid
                            };
                        }
                    );
                }
            });
        },
        onSelectYSDept(row) {
            console.log("row:", row);
            const matchedDept = this.YSDeptOptions.find(
                (item) => item.code === row
            );
            if (matchedDept) {
                this.seedFarmForm.ysDeptId = matchedDept.id;
                this.seedFarmForm.ysDeptName = matchedDept.name;
            }
        },
        onSelectDistributionStationt(row) {
            console.log(row);
            const distributionStationt = this.distributionStationsOptions.find(
                (item) => item.id === row
            );
            console.log(distributionStationt);
            if (distributionStationt) {
                this.seedFarmForm.defaultDtbStationsUuid
                    = distributionStationt.id;
            }
        },
        removeColumn() {
            let allowedTypes = this.personType.split(",");
            let isDisabled
                = allowedTypes.includes("S") || allowedTypes.includes("B");
            if (!isDisabled) {
                const index = this.mainTable.columns.findIndex(
                    (item) => item.key === "isPlanSale"
                );
                if (index > 0) {
                    this.mainTable.columns.splice(index, 1);
                }
                const index2 = this.mainTable.columns.findIndex(
                    (item) => item.key === "productBugCount"
                );
                if (index2 > 0) {
                    this.mainTable.columns.splice(index2, 1);
                }
            }
        },
        getBugProductCodeList(seedFarmUuid) {
            const request = {
                seedFarmUuid: seedFarmUuid
            };
            getBugProductCodeListBySeedFarmUuid(request).then((res) => {
                if (res.code === 0) {
                    this.$Modal.info({
                        title: "商品编号",
                        content: `<div style="max-height: 300px; overflow-wrap: break-word; overflow-y: auto;">${res.data}</div>`
                    });
                }
            });
        },
        async getDepartmentList() {
            try {
                const tableSearch = search.getSearchParams();
                search.closeAllConditions(tableSearch);
                const res = await getDepartmentList(tableSearch);
                if (res.code === 0) {
                    this.departmentList = res.data.records;
                }
                else {
                    this.$Message.error(res.message || '部门列表查询失败');
                }
            }
            catch (error) {
                console.error('获取部门列表失败:', error);
                this.$Message.error('部门列表查询失败');
            }
        },
        async getCompanyList() {
            try {
                const tableSearch = search.getSearchParams();
                search.closeAllConditions(tableSearch);
                const res = await getCompanyList(tableSearch);
                if (res.code === 0) {
                    this.companyList = res.data.records;
                }
                else {
                    this.$Message.error(res.message || '公司列表查询失败');
                }
            }
            catch (error) {
                console.error('获取公司列表失败:', error);
                this.$Message.error('公司列表查询失败');
            }
        }
    }
};
</script>

<style lang="less" scoped>
.form-button {
    margin-top: 5px;
}
</style>
